module.exports = __webpack_public_path__ + "static/ila-01227ac91330adefa34ed94a279f104d.svg";